import { apiFetch } from '../../lib/api';
import type {
  DripMessageTemplateRow,
  DripTemplateDetail,
  DripTemplateSummary,
  UpsertDripTemplateInput,
  CreateDripMessageTemplateInput,
  PatchDripMessageTemplateInput,
} from '@bcc/shared';

export async function fetchDripTemplatesList(token: string): Promise<DripTemplateSummary[]> {
  const r = await apiFetch<{ templates: DripTemplateSummary[] }>('/api/staff/drip-templates', { token });
  return r.templates;
}

export async function fetchDripTemplate(id: string, token: string): Promise<DripTemplateDetail> {
  return apiFetch<DripTemplateDetail>(`/api/staff/drip-templates/${encodeURIComponent(id)}`, { token });
}

export async function createDripTemplateApi(body: UpsertDripTemplateInput, token: string): Promise<DripTemplateDetail> {
  return apiFetch<DripTemplateDetail>('/api/staff/drip-templates', { method: 'POST', token, body: JSON.stringify(body) });
}

export async function updateDripTemplateApi(
  id: string,
  body: UpsertDripTemplateInput,
  token: string,
): Promise<DripTemplateDetail> {
  return apiFetch<DripTemplateDetail>(`/api/staff/drip-templates/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    token,
    body: JSON.stringify(body),
  });
}

export async function deleteDripTemplateApi(id: string, token: string): Promise<void> {
  await apiFetch<void>(`/api/staff/drip-templates/${encodeURIComponent(id)}`, { method: 'DELETE', token });
}

export async function fetchDripMessageTemplates(
  token: string,
  kind?: 'email' | 'sms',
): Promise<DripMessageTemplateRow[]> {
  const q = kind ? `?kind=${kind}` : '';
  const r = await apiFetch<{ templates: DripMessageTemplateRow[] }>(`/api/staff/drip-message-templates${q}`, { token });
  return r.templates;
}

export async function createDripMessageTemplateApi(
  body: CreateDripMessageTemplateInput,
  token: string,
): Promise<DripMessageTemplateRow> {
  return apiFetch<DripMessageTemplateRow>('/api/staff/drip-message-templates', {
    method: 'POST',
    token,
    body: JSON.stringify(body),
  });
}

export async function patchDripMessageTemplateApi(
  id: string,
  body: PatchDripMessageTemplateInput,
  token: string,
): Promise<DripMessageTemplateRow> {
  return apiFetch<DripMessageTemplateRow>(`/api/staff/drip-message-templates/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    token,
    body: JSON.stringify(body),
  });
}

